import { render, staticRenderFns } from "./SitesStatsComponent.vue?vue&type=template&id=a3c4cb48&scoped=true"
import script from "./SitesStatsComponent.vue?vue&type=script&lang=js"
export * from "./SitesStatsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c4cb48",
  null
  
)

export default component.exports